//#region IMPORT
import React from 'react';
import { Unstable_Grid2 as Grid } from '@mui/material';
import { AuthButton } from '../../../../Components/MUIs';
import GridFunctions from '../../../../Services/agGrid/ag-Grid-functions';
import { BusinessGridCommon } from '../../../../Components/BusinessGridCommon';
import { getColumnDefs1 } from './COD_BASIC_ColumnDefs';
//#endregion

function COD_BASIC(props) {
  const columnDefs = getColumnDefs1({
    lanList: props.lanList,
    codeList: props.codeList,
    groupCdList: props.groupCdList,
    gridRef: props.gridRef,
    rowData: props.rowData,
    selectedRowNosRef: props.selectedRowNosRef,
    lastCheckedIndexRef: props.lastCheckedIndexRef,
    handleRowSelection: props.handleRowSelection,
    DeleteNewRow: props.DeleteNewRow,
    RestoreRow: props.RestoreRow,
  });

  const addRow = () => {
    GridFunctions.addClick(props.gridRef, {}, {});
  };

  return (
    <Grid container spacing={2} columns={{ xs: 4, sm: 8, md: 12 }}>
      <Grid xs={4} md={12}>
        <AuthButton
          menuId="Code"
          printYn="N"
          addClick={addRow}
          saveClick={() => props.SaveLogic1?.()}
          deleteClick={() => props.DeleteClick1?.()}
          searchYn="Y"
          searchClick={(e) => props.gridRef?.current?.api?.setQuickFilter(e)}
          grids={
            <BusinessGridCommon
              getRowId={(p) => String(p.data?.no ?? '')}
              gridRef={props.gridRef}
              editable
              columnDefs={columnDefs}
              rowData={props.rowData}
              setSelectedRowData={props.setSelectedRowData}
              setChangedRowData={props.setChangedRowData}
              getRowStyle={GridFunctions.getRowStyle}
              onSelectionChanged={() => props.OnSelectionChanged?.()}
              addClick1={addRow}
              deleteClick1={() => props.DeleteClick1?.()}
              refreshClick1={() => {
                props.RefreshLogic1?.();
              }}
            />
          }
        />
      </Grid>
    </Grid>
  );
}

export default COD_BASIC;
